import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/JobPage";
import GoogleJobsSchema from "@/ui/GoogleJobsSchema";
import { jobs_helper } from "@/helpers/jobs_helper";
import { getJobMetaDescription } from "@/functions/getJobMetaDescription";
import { parseRoute } from "@/functions/parseRoute";
import sourceflowEnums from "@/sourceflow.enums";
import { useLocale } from "@/hooks/useLocale";

export default function Page({ content, job, meta }) {
  const locale = useLocale();

  return (
    <>
      <GoogleJobsSchema
        job={job}
        employment_type={job.categories.includes(sourceflowEnums.categories.type.contract) ? "CONTRACTOR" : "FULL_TIME"}
        site_domain_link={sourceflowEnums.config.baseUrl}
        site_name={meta[locale]?.siteName ?? sourceflowEnums.config.siteName}
        site_google_logo_link={sourceflowEnums.config.favIcon}
      />
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const job = jobs_helper.find(url_slug);
  const similar = jobs_helper.getSimilarJobs({
    job,
    arrayOfCategoryIds: [sourceflowEnums.categories.sectors.id],
  });

  const routerKey = "jobs.item";
  const routerProp = parseRoute(routerKey, { url_slug });

  const location = job.derived_info?.locations?.[0].postal_address?.address_lines[0] ?? job.addresses[0];
  const inLocation = location && !location.includes("None Specified") ? ` in ${location}` : "";

  return {
    props: {
      footer: { showForm: false },
      meta: {
        en: {
          title: [`${job.title.trim()} Job${inLocation}`, job.salary_package].filter(Boolean).join(" | "),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
          description: getJobMetaDescription(job.description),
          siteName: "Gravitas Recruitment Group",
        },
      },
      router: routerProp,
      job,
      content: [
        { component: "JobPageIntroSection", props: { className: "", ...job } },
        {
          component: "JobPageContentSection",
          props: { className: "py-4 py-md-5", ...job, similar },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: jobs_helper.toPaths(),
    fallback: false,
  };
}
